import styled from 'styled-components'

const variants = {}

const FieldGroup = styled.div`
  ${({ variant }) => variants[variant]}
`
export default FieldGroup
